import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'app';
  isIE = false;
  currentYear;
  ngOnInit() {
     this.currentYear = new Date().getFullYear();
     this.detectIE();
  }



   detectIE() {
    const ua = window.navigator.userAgent;  //Check the userAgent property of the window.navigator object
    const msie = ua.indexOf('MSIE '); // IE 10 or older
    const trident = ua.indexOf('Trident/'); //IE 11
    this.isIE = (msie > 0 || trident > 0);
}

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts